import React from "react";
import Modal from "../../../../atoms/Popup/Popup";
import "../CancelSessionModal/CancelSessionModal.scss";

type Props = {
  isOpen: boolean;
  sessionTitle?: string;
  submitting?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const DeleteDraftModal: React.FC<Props> = ({
  isOpen,
  sessionTitle,
  submitting,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal
      show={isOpen}
      headerText="Delete draft"
      onClose={onClose}
      size="sm"
      placement="top"
    >
      <div className="wf-cancel-modal">
        <p className="wf-cancel-modal__lead">
          Delete draft{sessionTitle ? ` “${sessionTitle}”` : ""}? This cannot be
          undone.
        </p>
        <div className="wf-cancel-modal__actions">
          <button
            type="button"
            className="wf-btn ghost"
            onClick={onClose}
            disabled={submitting}
          >
            Keep draft
          </button>
          <button
            type="button"
            className="wf-btn danger"
            onClick={onConfirm}
            disabled={submitting}
          >
            {submitting ? "Deleting…" : "Delete draft"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteDraftModal;
